import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n';

export const initialState = {
	invitation: {
		data: {},
		hasBeenLoaded: false,
		isLoading: false,
		error: {
			detail: '',
			message: ''
		}
	}
};

export const invitationSlice = createSlice({
	name: 'invitation',
	initialState,
	reducers: {
		getInvitation: (state) => {
			state.invitation.isLoading = true;
		},
		getInvitationCompleted: (state, action) => {
			state.invitation.isLoading = false;
			state.invitation.hasBeenLoaded = true;
			state.invitation.error = undefined;
			state.invitation.isLoading = action.payload;
		},
		getInvitationFailed: (state, action) => {
			const detail = i18n.t(`errors:${action.payload.message.type}.detail`);
			const message = i18n.t(`errors:${action.payload.message.type}.message`);

			state.invitation.isLoading = false;
			state.invitation.hasBeenLoaded = true;
			state.invitation.error.detail = detail;
			state.invitation.error.message = message;
			state.invitation.data = undefined;
		}
	}
});

export const { getInvitation, getInvitationCompleted, getInvitationFailed } =
	invitationSlice.actions;

export default invitationSlice.reducer;
